<div class="info-container border-radius d-flex">
    <div class="info">
        <div class="info-header">
            <div>
                <ng-content select="[id=info-title]"></ng-content>
            </div>
        </div>

        <ng-content select="[id=info-small-text]"></ng-content>

        <ng-content select="[id=info-custom-icons]"></ng-content>

        @if (icons && !!icons.length) {
            <div class="feed-icons">
                @for (item of icons; track item) {
                    <div class="feed-icon">
                        <kui-icon [name]="item.name" class="text-{{ item.color }}" [fill]="true" [title]="item.tooltip"></kui-icon>
                    </div>
                }
            </div>
        }
    </div>

    @if (indicators && !!indicators.length) {
        @for (item of indicators; track item) {
            <div class="indicator bg-{{ item }}"></div>
        }
    } @else {
        <div class="indicator"></div>
    }
</div>
